import { useState } from 'react';
import { Plus, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AddChildRequestDialog } from './components/AddChildRequestDialog';
import { AddInfoRequestDialog } from './components/AddInfoRequestDialog';
import { RequestsList } from './components/RequestsList';
import { useUserRequests } from './hooks/useUserRequests';

export function UserRequests() {
  const [showAddChild, setShowAddChild] = useState(false);
  const [showAddInfo, setShowAddInfo] = useState(false);
  const { requests, handleAddChildRequest, handleAddInfoRequest } = useUserRequests();

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-2xl font-bold text-gray-900">طلباتي</h2>
        <div className="flex flex-wrap gap-2">
          <Button onClick={() => setShowAddChild(true)} className="hover:bg-secondary">
            <Plus className="h-4 w-4 ml-2" />
            طلب إضافة مولود
          </Button>
          <Button onClick={() => setShowAddInfo(true)} className="hover:bg-secondary">
            <FileText className="h-4 w-4 ml-2" />
            طلب إضافة معلومات
          </Button>
        </div>
      </div>

      <RequestsList requests={requests} />

      <AddChildRequestDialog
        open={showAddChild}
        onClose={() => setShowAddChild(false)}
        onSubmit={({ childName, parentId, phoneNumber }) => {
          handleAddChildRequest({ childName, parentId, phoneNumber });
          setShowAddChild(false);
        }}
      />

      <AddInfoRequestDialog
        open={showAddInfo}
        onClose={() => setShowAddInfo(false)}
        onSubmit={handleAddInfoRequest}
      />
    </div>
  );
}